var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("LayoutForm", [
    _vm.id
      ? _c("div", { staticClass: "form__title" }, [
          _c("h1", [_vm._v("Edit Event")]),
        ])
      : _c("div", { staticClass: "form__title" }, [
          _c("h1", [_vm._v("Create Event")]),
        ]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "form",
        attrs: { novalidate: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c(
          "fieldset",
          { staticClass: "form__group" },
          [
            _c("ValidationAlert", {
              attrs: { "error-list": _vm.errors.collect("server") },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "form__group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.eventName,
                    expression: "formData.eventName",
                  },
                  { name: "validate", rawName: "v-validate" },
                ],
                staticClass: "form__control",
                attrs: {
                  id: "activityName",
                  name: "activityName",
                  placeholder: "Enter a name for your Activity...",
                  required: "",
                },
                domProps: { value: _vm.formData.eventName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "eventName", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "form__label", attrs: { for: "activityName" } },
                [_vm._v("Event name")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form__validation" }, [
                _vm._v(_vm._s(_vm.errors.first("eventName"))),
              ]),
            ]),
            _vm._v(" "),
            _c("FormControlDatetimePicker", {
              attrs: {
                "default-value": _vm.startDate,
                "min-date": null,
                "max-date": null,
                label: "Event Start Date",
              },
              model: {
                value: _vm.formData.start.dateTimeString,
                callback: function ($$v) {
                  _vm.$set(_vm.formData.start, "dateTimeString", $$v)
                },
                expression: "formData.start.dateTimeString",
              },
            }),
            _vm._v(" "),
            _c("FormControlDatetimePicker", {
              attrs: {
                "default-value": _vm.endDate,
                "min-date": null,
                "max-date": null,
                label: "Event End Date",
              },
              model: {
                value: _vm.formData.end.dateTimeString,
                callback: function ($$v) {
                  _vm.$set(_vm.formData.end, "dateTimeString", $$v)
                },
                expression: "formData.end.dateTimeString",
              },
            }),
            _vm._v(" "),
            _c("FormControlDatetimePicker", {
              attrs: {
                "default-value": _vm.bilateralStartDate,
                "min-date": null,
                "max-date": null,
                label: "Bilateral Start Date",
              },
              model: {
                value: _vm.formData.bilateralStart.dateTimeString,
                callback: function ($$v) {
                  _vm.$set(_vm.formData.bilateralStart, "dateTimeString", $$v)
                },
                expression: "formData.bilateralStart.dateTimeString",
              },
            }),
            _vm._v(" "),
            _c("FormControlDatetimePicker", {
              attrs: {
                "default-value": _vm.bilateralEndDate,
                "min-date": null,
                "max-date": null,
                label: "Bilateral End Date",
              },
              model: {
                value: _vm.formData.bilateralEnd.dateTimeString,
                callback: function ($$v) {
                  _vm.$set(_vm.formData.bilateralEnd, "dateTimeString", $$v)
                },
                expression: "formData.bilateralEnd.dateTimeString",
              },
            }),
            _vm._v(" "),
            _c("FormControlDatetimePicker", {
              attrs: {
                "default-value": _vm.signupEnd,
                "min-date": null,
                "max-date": null,
                label: "Signup End Date",
              },
              model: {
                value: _vm.formData.signupEnd.dateTimeString,
                callback: function ($$v) {
                  _vm.$set(_vm.formData.signupEnd, "dateTimeString", $$v)
                },
                expression: "formData.signupEnd.dateTimeString",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "form__group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.location,
                    expression: "formData.location",
                  },
                  { name: "validate", rawName: "v-validate" },
                ],
                staticClass: "form__control",
                attrs: {
                  id: "location",
                  name: "location",
                  placeholder: "Enter a location...",
                },
                domProps: { value: _vm.formData.location },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "location", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "form__label", attrs: { for: "website" } },
                [_vm._v("Event Location")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form__validation" }, [
                _vm._v(_vm._s(_vm.errors.first("location"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form__group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.bilateralMeetingRoom,
                    expression: "formData.bilateralMeetingRoom",
                  },
                  { name: "validate", rawName: "v-validate" },
                ],
                staticClass: "form__control",
                attrs: {
                  id: "bilateralMeetingRoom",
                  name: "bilateralMeetingRoom",
                  placeholder: "Enter a meeting room...",
                },
                domProps: { value: _vm.formData.bilateralMeetingRoom },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.formData,
                      "bilateralMeetingRoom",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form__label",
                  attrs: { for: "bilateralMeetingRoom" },
                },
                [_vm._v("Bilateral Meeting Room")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form__validation" }, [
                _vm._v(_vm._s(_vm.errors.first("bilateralMeetingRoom"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form__group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.popupTitle,
                    expression: "formData.popupTitle",
                  },
                  { name: "validate", rawName: "v-validate" },
                ],
                staticClass: "form__control",
                attrs: {
                  id: "popupTitle",
                  name: "popupTitle",
                  placeholder: "Enter a title for your popup...",
                },
                domProps: { value: _vm.formData.popupTitle },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "popupTitle", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "form__label", attrs: { for: "popupTitle" } },
                [_vm._v("Popup Title")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form__validation" }, [
                _vm._v(_vm._s(_vm.errors.first("popupTitle"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form__group" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.popupCopy,
                    expression: "formData.popupCopy",
                  },
                  { name: "validate", rawName: "v-validate" },
                ],
                staticClass: "form__control",
                attrs: {
                  id: "popupCopy",
                  name: "popupCopy",
                  placeholder: "Enter a description for your popup...",
                },
                domProps: { value: _vm.formData.popupCopy },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "popupCopy", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "form__label", attrs: { for: "popupCopy" } },
                [_vm._v("Popup Description")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form__validation" }, [
                _vm._v(_vm._s(_vm.errors.first("popupCopy"))),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form__group form__background" },
              [
                _vm.formData.backgroundUrl
                  ? _c("img", {
                      staticClass: "form__image",
                      attrs: {
                        src: _vm.formData.backgroundUrl,
                        alt: "Activity background image",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("FileUpload", {
                  attrs: {
                    multiple: false,
                    name: "background",
                    label: "Background Image",
                  },
                  model: {
                    value: _vm.formData.background.uuid,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData.background, "uuid", $$v)
                    },
                    expression: "formData.background.uuid",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__group" }, [
              _c("div", { staticClass: "toggle-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.disabled,
                      expression: "formData.disabled",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "toggle",
                  attrs: {
                    id: "show-date",
                    name: "disabled",
                    type: "radio",
                    required: "",
                  },
                  domProps: {
                    value: true,
                    checked: _vm.formData.disabled === true,
                    checked: _vm._q(_vm.formData.disabled, true),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.formData, "disabled", true)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "toggle", attrs: { for: "show-date" } },
                  [_vm._v("Yes")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.disabled,
                      expression: "formData.disabled",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "toggle",
                  attrs: {
                    id: "hide-date",
                    name: "disabled",
                    type: "radio",
                    required: "",
                  },
                  domProps: {
                    value: false,
                    checked: _vm.formData.disabled === false,
                    checked: _vm._q(_vm.formData.disabled, false),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.formData, "disabled", false)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "toggle", attrs: { for: "hide-date" } },
                  [_vm._v("No")]
                ),
              ]),
              _vm._v(" "),
              _c("label", { staticClass: "form__label" }, [
                _vm._v("Hide event on the app?"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__validation" }, [
                _vm._v(_vm._s(_vm.errors.first("disabled"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form__group form__group--submit" }, [
              _c(
                "button",
                { staticClass: "btn btn--primary", attrs: { type: "submit" } },
                [_vm._v("Save")]
              ),
            ]),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }